import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import React from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import Image1 from '../../assets/banner/1.png';
import Image2 from '../../assets/banner/2.png';
import Image3 from '../../assets/banner/3.png';
import Image4 from '../../assets/banner/4.png';
import Image5 from '../../assets/banner/5.png';

const ImageSwiper = () => {
    // Example images array
    const images = [
        { id: 1, src: Image1, alt: 'Image 1' },
        { id: 2, src: Image2, alt: 'Image 2' },
        { id: 3, src: Image3, alt: 'Image 3' },
        { id: 4, src: Image4, alt: 'Image 4' },
        { id: 5, src: Image5, alt: 'Image 5' },
    ]

    return (
        <Swiper
            spaceBetween={50}
            slidesPerView={1}
            autoplay={{ delay: 3000 }}
            modules={[Autoplay]}
            className='w-[96%] mx-auto md:w-[80%]'
        >
            {images.map((image) => (
                <SwiperSlide key={image.id}>
                    <img src={image.src} alt={image.alt} className='w-full h-[200px] shadow-lg md:h-[500px] object-cover' />
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default ImageSwiper;